import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ErrorReportService {

  constructor(
    private snackbar: MatSnackBar
  ) { 

  }

  showMessage(err, message: string = null) {

    console.error(err);
    if(message === null)
      message = 'Desculpe ocorreu um erro, tente novamente',
    
    this.snackbar.open(message, 'OK', { duration: 3000 });    

  }

}
